export function qrPopup() {
    const overlay = document.querySelector(".qr-popup .overlay");
    const closeBtn = document.querySelector(".qr-popup .close");
    const openBtn = document.querySelector(".qr-popup-opener");
    openBtn.addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.add("qr-popup-active");
    });
    closeBtn.addEventListener("click", () => {
        ClosePopup();
    });

    overlay.addEventListener("click", () => {
        ClosePopup();
    });

    function ClosePopup() {
        document.body.classList.remove("qr-popup-active");
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/qrPopap.js